// extracted by mini-css-extract-plugin
export var hidden = "_t9-0";